const uri:any = {
    getembedinfo: "/embedinfo/getembedinfo",
   
    }
export default (uri);